"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __importStar(require("./colors"));
var dimensions_1 = __importDefault(require("./dimensions"));
var typography_1 = __importDefault(require("./typography"));
var secondaryBorderWidth = 2;
var defaultButtonStyles = {
    background: "transparent",
    borderRadius: 0,
    color: colors_1.default.white,
    cursor: "pointer",
    fontFamily: typography_1.default.fonts.body,
    fontSize: typography_1.default.fontSizes[2],
    fontWeight: typography_1.default.fontWeights.body,
    letterSpacing: typography_1.default.letterSpacing.caps,
    lineHeight: typography_1.default.lineHeightsV4[2],
    outline: "none",
    overflow: "hidden",
    px: dimensions_1.default.sizes[3],
    position: "relative",
    ":focus": {
        filter: "brightness(1.1)",
    },
    ":hover": {
        filter: "brightness(1.3)",
    },
    "&:active": {
        boxShadow: "inset 0 0 5px " + colors_1.default.offBlack,
    },
    "&:disabled": {
        cursor: "not-allowed",
        filter: "grayscale(1)",
    },
};
var defaultSocialButton = {
    cursor: "pointer",
    backgroundColor: colors_1.mainColors.white,
    textAlign: "center",
    width: 5,
    height: 5,
    borderRadius: 0,
};
var tertiaryDefaults = __assign(__assign({}, defaultButtonStyles), { color: colors_1.default.primary });
exports.default = {
    primary: __assign(__assign({}, defaultButtonStyles), { background: colors_1.gradients.lightToDark }),
    large: __assign(__assign({}, defaultButtonStyles), { background: colors_1.default.primary, variant: "primary", fontSize: 6, lineHeight: "100%", px: dimensions_1.default.sizes[6], py: dimensions_1.default.sizes[2] }),
    secondary: __assign(__assign({}, defaultButtonStyles), { border: "2px solid " + colors_1.default.primary, color: colors_1.default.primary, py: dimensions_1.default.space[2] - secondaryBorderWidth + "px" }),
    tertiaryWithoutChevron: __assign({}, tertiaryDefaults),
    tertiary: __assign({}, tertiaryDefaults),
    overflow: __assign(__assign({}, defaultButtonStyles), { background: colors_1.default.grey900, color: "transparent", overflow: "hidden", width: "56px", "::before": {
            color: colors_1.default.secondaryLight,
            content: "'\\25CF\\25CF\\25CF'",
            left: "50%",
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
        } }),
    close: {
        color: "white",
        cursor: "pointer",
        height: 6,
        opacity: 0.8,
        outline: "none",
        transition: "opacity 0.2s",
        width: 6,
        ":hover": {
            opacity: 1,
        },
    },
    languagePicker: {
        bg: "transparent",
        color: "white",
        cursor: "pointer",
        display: "block",
        fontSize: 1,
        mb: "4px",
        outline: "none",
        p: 0,
        ":hover": {
            color: colors_1.mainColors.primary,
        },
    },
    icon: {
        cursor: "pointer",
        padding: 0,
        backgroundColor: "white",
        mask: "no-repeat center",
        maskSize: "contain",
        height: 2,
        width: 2,
        ":hover": {
            backgroundColor: colors_1.mainColors.primary,
        },
        ":focus": {
            border: "none",
            outline: "none",
        },
    },
    basicSocial: __assign({}, defaultSocialButton),
    social: __assign(__assign({}, defaultSocialButton), { filter: "brightness(0.9)", "&:focus, &:hover": {
            filter: "brightness(1.0)",
        }, ":active": {
            boxShadow: "inset 0 0 5px " + colors_1.default.offBlack,
        } }),
};
